var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-form',{attrs:{"schema":_vm.schemas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }